<template>
    <div>
        <div class="form-group" v-for="(foot, index) in footer" :key="index">
            <label class="form-label">{{$t('label.footer')}} {{index + 1}}</label>
            <div class="input-group bg-white shadow-inset-2">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent border-right-0">
                        <i class="fas fa-text"></i>
                    </span>
                </div>
                <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.footer') + ' ' + (index + 1)" v-model="receiptFooter[index]">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'receiptFooter',
    props:{
        footer: { type: Array }
    },
    computed:{
        receiptFooter(){
            var ret = [];
            for(var i=0; i<this.footer.length; i++){
                ret.push(this.footer[i]);
            }
            return ret;
        }
    },
    methods:{
        submitFooter(){
            var data = {
                footer: this.receiptFooter
            }
            return data;
        }
    }
}
</script>